const initialState = {
    processingUploadMassiveAssignment: false,
    successUploadMassiveAssignment: false,
    errorUploadMassiveAssignment: false,
    massiveAssignmentResult: null,
    processingUploadCancelAssignment: false,
    successUploadCancelAssignment: false,
    errorUploadCancelAssignment: false,
    resultCancelAssignment: null,
};
  
const assignOperatorReducer = (state = initialState, payload) => {
    switch (payload.type) {
        case "UPLOAD_MASSIVE_ASSIGNMENT_FILE_PROCESSING":
        return {
            ...state,
            processingUploadMassiveAssignment: true,
            successUploadMassiveAssignment: false,
            errorUploadMassiveAssignment: false,
        };
        case "UPLOAD_MASSIVE_ASSIGNMENT_FILE_SUCCESS":
        return {
            ...state,
            processingUploadMassiveAssignment: false,
            successUploadMassiveAssignment: true,
            errorUploadMassiveAssignment: false,
            massiveAssignmentResult: payload.value,
        };
        case "UPLOAD_MASSIVE_ASSIGNMENT_FILE_ERROR":
        return {
            ...state,
            processingUploadMassiveAssignment: false,
            successUploadMassiveAssignment: false,
            errorUploadMassiveAssignment: true,
        };
        case "UPLOAD_CANCEL_ASSIGNMENT_FILE_PROCESSING":
        return {
            ...state,
            processingUploadCancelAssignment: true,
            successUploadCancelAssignment: false,
            errorUploadCancelAssignment: false,
        };
        case "UPLOAD_CANCEL_ASSIGNMENT_FILE_SUCCESS":
        return {
            ...state,
            processingUploadCancelAssignment: false,
            successUploadCancelAssignment: true,
            errorUploadCancelAssignment: false,
            resultCancelAssignment: payload.value,
        };
        case "UPLOAD_CANCEL_ASSIGNMENT_FILE_ERROR":
        return {
            ...state,
            processingUploadCancelAssignment: false,
            successUploadCancelAssignment: false,
            errorUploadCancelAssignment: true,
        };
        case "RESET_CANCEL_ASSIGNMENT_FILE":
        return {
            ...state,
            resultCancelAssignment: [],
            successUploadCancelAssignment: false,
        };
        default:
        return state;
    }
};

export const assignOperatorActions = {
    UPLOAD_MASSIVE_ASSIGNMENT_FILE_PROCESSING: 'UPLOAD_MASSIVE_ASSIGNMENT_FILE_PROCESSING',
    UPLOAD_MASSIVE_ASSIGNMENT_FILE_SUCCESS: 'UPLOAD_MASSIVE_ASSIGNMENT_FILE_SUCCESS',
    UPLOAD_MASSIVE_ASSIGNMENT_FILE_ERROR: 'UPLOAD_MASSIVE_ASSIGNMENT_FILE_ERROR',
    UPLOAD_CANCEL_ASSIGNMENT_FILE_PROCESSING: 'UPLOAD_CANCEL_ASSIGNMENT_FILE_PROCESSING',
    UPLOAD_CANCEL_ASSIGNMENT_FILE_SUCCESS: 'UPLOAD_CANCEL_ASSIGNMENT_FILE_SUCCESS',
    UPLOAD_CANCEL_ASSIGNMENT_FILE_ERROR: 'UPLOAD_CANCEL_ASSIGNMENT_FILE_ERROR',
}

export default assignOperatorReducer;